import React from 'react'

import { Box } from '@domain-group/suit-theme'

interface FooterProps {
  children: React.ReactNode,
}

const Footer = (props: FooterProps) => {
  const { children } = props

  return (
    <Box
      alignItems="center"
      borderTop="1px solid"
      borderColor="lineColor"
      flexDirection={['column', 'row']}
      padding="large"
    >
      {children}
    </Box>
  )
}

export default Footer
